import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { isValidDate } from '~/utility/date/isValidDate'
import { isDayPast } from '~/utility/date/relative'

export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  if (query.arrive) {
    const arrive = new Date(query.arrive as string)
    const depart = new Date(query.depart as string)

    if (
      !isValidDate(query.arrive) ||
      !isValidDate(query.depart) ||
      isDayPast(arrive) ||
      depart < arrive
    ) {
      const redirectQuery = {
        ...query,
        arrive: undefined,
        depart: undefined,
      }
      return navigateTo(
        {
          path,
          query: redirectQuery,
          hash: hash ?? undefined,
        },
        { redirectCode: 301 },
      )
    }
  }
})
